/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".de-loader__container[_ngcontent-%COMP%]{height:100%;position:relative;width:100%}.de-loader__overlay[_ngcontent-%COMP%]{background:rgba(255,255,255,.7);display:block;position:fixed;top:0;left:0;right:0;bottom:0;width:100%;height:100%;z-index:100}.de-loader__svg-container[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);width:20rem}"];
export { styles as styles };
